import { UserService } from '../../services/user/user.service';

/**
 * A controller that underpins the left hand navigation menu in the application
 */
export class NavBarController {
  public static $inject = [
    '$mdSidenav',
    '$scope',
    '$rootScope',
    '$state',
    '$mdMedia',
    '$mdComponentRegistry',
    'userService',
    '$transitions'
  ];

  private openSection: InterACT.Interfaces.IMenuItem;
  private openPage: InterACT.Interfaces.IMenuItem;
  private stateChangeWatcher: Function;
  private navMenu: Array<InterACT.Interfaces.IMenuItem> = [
    {
      name: 'HOME',
      state: 'home',
      iconName: 'home',
      permissionRef: 'home'
    },
    {
      name: 'ACCOUNT_SEARCH',
      state: 'customers',
      iconName: 'search',
      permissionRef: 'customers'
    },
    {
      name: 'TAP_EVENTS',
      state: 'tap-events',
      iconName: 'cloud_upload',
      permissionRef: 'tap-event'
    },
    {
      name: 'ITSO_UPLOAD',
      state: 'decoded-itso-message-upload',
      iconName: 'cloud_upload',
      permissionRef: 'itso-upload'
    },
    {
      name: 'TAPS_REPORT',
      state: 'taps-report',
      iconName: 'assignment',
      permissionRef: 'reports'
    },
    {
      name: 'ABT_CONFIGURATION',
      state: 'abt-configuration',
      iconName: 'settings',
      permissionRef: 'abt-configuration',
      pages: [{
        name: 'USAGE_CONSTRUCTION_RULES',
        state: 'journey-construction-rules',
        permissionRef: 'abt-configuration'
      }, {
        name: 'USAGE_RATING_RULES',
        state: 'usage-rating-rules',
        permissionRef: 'abt-configuration',
        linkedStates: [
          'manage-best-value-calculation-rule'
        ]
      }, {
        name: 'SPECIAL_DAYS.SPECIAL_DAYS',
        state: 'special-days',
        permissionRef: 'abt-configuration'
      }, {
        name: 'PRODUCT_VALIDITY_TIMEBANDS',
        state: 'view-timebands',
        permissionRef: 'abt-configuration'
      }]
    },
    {
      name: 'SETTLEMENT_PERIOD',
      state: 'settlement-period',
      iconName: 'assignment_turned_in',
      permissionRef: 'settlement'
    },
    {
      name: 'UNRATED_JOURNEYS',
      state: 'unrated-journeys',
      iconName: 'map',
      permissionRef: 'unrated-journeys'
    },
    {
      name: 'PRODUCTS',
      state: 'products_overview',
      iconName: 'dashboard',
      permissionRef: 'products',
      pages: [
        {
          name: 'CATALOGUES',
          state: 'catalogues.list',
          permissionRef: 'catalogues',
          linkedStates: [
            'catalogues.create', 'catalogues.copy', 'catalogues.edit',
            'products', 'productsCreate', 'productsCopy', 'productsEdit',
            'catalogue.dashboard', 'catalogue.product-list',
            'catalogue.catalogue_history', 'catalogue.catalogue_history_detail',
            'catalogue.catalogue_versions', 'catalogue.catalogue_notifications',
            'variants', 'variants.list', 'variants.product_fields', 'variantsCreate', 'variantsCopy',
            'variantsEdit', 'variants.details', 'products_overview'
          ]
        }
      ]
    },
    {
      name: 'APPORTIONMENT',
      state: 'x',
      iconName: 'assignment',
      permissionRef: 'apportionment',
      pages: [
        {
          name: 'RAIL_SETTLEMENT.LENNON',
          state: 'rail-settlement',
          permissionRef: 'rail-settlement'
        }
      ]
    },
    {
      name: 'FULFILMENT',
      state: 'fulfilment',
      iconName: 'cloud_download',
      permissionRef: 'fulfilment',
      pages: [
        {
          name: 'FULFILMENT_DASHBOARD',
          state: 'fulfilment-dashboard',
          permissionRef: 'fulfilment-dashboard',
        },
        {
          name: 'FULFILMENT_REQUESTS',
          state: 'fulfilment-requests',
          permissionRef: 'fulfilment',
          linkedStates: [
            'fulfilment-request', 'fulfilment-request.summary', 'fulfilment-request.timeline', 'fulfilment-request.details'
          ]
        }
      ]
    },
    {
      name: 'OPERATORS',
      state: 'operators',
      iconName: 'directions_bus',
      permissionRef: 'operators',
      linkedStates: [
        'operators-create', 'operator', 'operator.summary', 'operator.edit', 'operator.services',
        'transport-operator-services', 'operator.services-create', 'operator.services-edit',
        'operator.schedules', 'operator.schedules-create', 'operator.schedules-edit'
      ]
    },
    {
      name: 'TRANSPORT_LOCATIONS',
      state: 'transport-locations',
      iconName: 'location_on',
      permissionRef: 'transport-locations',
      linkedStates: [],
      pages: [{
        name: 'ZONE_UPLOADS',
        state: 'transport-zones',
        permissionRef: 'transport-locations',
        linkedStates: ['transport-zone-edit']
      }, {
        name: 'LOCATION_UPLOADS',
        state: 'transport-locations-upload',
        permissionRef: 'transport-locations',
        linkedStates: ['transport-locations-publish']
      }
      ]
    }
  ];

  constructor(
    private $mdSidenav,
    private $scope,
    private $rootScope,
    private $state: ng.ui.IStateService,
    private $mdMedia,
    private $mdComponentRegistry,
    private userService: UserService,
    private $transitions
  ) {
    this.activate();
  }

  /**
   * A method that determines the logo to use
   * @returns the path of the image to use
   */
  public determineLogoPath() {
    return 'assets/images/logo-white.svg';
  }

  /**
   * A method that determines the icon to use
   * @returns the path of the image to use
   */
  public determineHideIconPath() {
    return 'assets/images/icon-hide-menu-white.svg';
  }

  /**
   * A method that determines the class to use for the side navigation pane
   * @returns the class name
   */
  public getSideNavClass() {
    return 'nav-off-white';
  }

  /**
   * A method that determines the class to use for the sub menu items in a menu section
   * @returns the class name
   */
  public getMenuSubClass() {
    return 'nav-dark-white';
  }

  /**
   * A method that will check if a given menu section contains subpages and determines if the given section should be
   * made visible to the usr
   * @param section the section to perform checks against
   * @param checkHasPages whether to check the supplied menu section has pages defined or not
   */
  public checkPagesAndPermissions(section: InterACT.Interfaces.IMenuItem, checkHasPages: boolean): Boolean {
    return _.has(section, 'pages') === checkHasPages && this.shouldShowMenuItem(section);
  }

  /**
 * Gets a value indicating whether the menu item with the supplied name should be shown or not
 * @param menuItemName the name of menu item
 * @returns a value indicating whether the menu item with the supplied name should be shown or not
 */
  public shouldShowMenuItem(section: InterACT.Interfaces.IMenuItem): Boolean {
    const menuItemPermissionDetails: InterACT.Interfaces.IUIPermissionDetails = this.userService.permissions['ui'][section.permissionRef];
    return section.permissionRef && menuItemPermissionDetails ? menuItemPermissionDetails.canAccess : false;
  }

  /**
   * A method that indicates whether the supplied section should be highlighted or not
   *
   * @param section the section to get the highlighted status of
   * @returns a value that indicates if the supplied section should be highlighted or not
   */
  public shouldHighlightSection = (section: InterACT.Interfaces.IMenuItem) => {
    return section === this.openSection && !this.openPage;
  }

  /**
   * A method that indicates whether the supplied section should be highlighted or not
   *
   * @param page the page to get the highlighted status of
   * @returns a value that indicates if the supplied page should be highlighted or not
   */
  public shouldHighlightPage = (page: InterACT.Interfaces.IMenuItem) => {
    return page === this.openPage;
  }

  /**
   * A method that determines if the supplied section is open or not
   *
   * @param section the section to determine the opened status of
   * @returns returns a value that indicates if the supplied section is open or not
   */
  public isSectionOpen = (section: InterACT.Interfaces.IMenuItem) => {
    return section === this.openSection;
  }

  /**
   * A method that closes the side navigation panel on the application
   * @param forceClose tells the controller whether the sideNav should be forced to close
   */
  public closeSideNav = (forceClose: boolean) => {
    if (!forceClose) {
      return;
    }
    this.$mdSidenav('left').close();
  }

  /**
   * A method that toggles the open section on the navbar.
   *
   * @param section the section to be toggled
   */
  public toggleOpenSection = (section: InterACT.Interfaces.IMenuItem) => {
    if (this.isSectionOpen(section) && (!this.openPage || !this.isOpenPageInSection())) {
      this.openSection = undefined;
    } else {
      this.openSection = section;
    }
  }

  /**
   * Determines whether the nav should be locked open
   *
   * @returns true when the nav is open
   */
  public isNavLockedOpen = () => {
    return this.isNavOpen();
  }

  /**
   * Determines whether the nav is open
   *
   * @returns true if the nav is open
   */
  public isNavOpen = () => {
    return this.$mdSidenav('left').isOpen();
  }

  /**
   * Determines whether the open page is part of the open section
   *
   * @returns true if the openPage is in openSection
   */
  private isOpenPageInSection() {
    return this.openSection.pages.some((page) => {
      return this.openPage.name === page.name;
    });
  }

  /**
   * Activates the navbar controller by setting the menu section
   */
  private activate() {
    this.$mdComponentRegistry.when('left').then(() => {
      this.$mdSidenav('left').open();
    });

    this.setOpenItemsForState(this.$state.current.name);
    this.$transitions.onSuccess({}, (trans) => {
      this.setOpenItemsForState(trans.to().name);
    });
  }

  /**
   * A method that sets the open menu section/page based on the supplied state name
   *
   * @param stateName the name of the state to set the open menu section/page for
   */
  private setOpenItemsForState(stateName: string) {
    this.openSection = undefined;
    this.openPage = undefined;

    _.each(this.navMenu, (section) => {

      if (section.state === stateName || (section.linkedStates && section.linkedStates.indexOf(stateName) >= 0)) {
        this.openSection = section;
        return;
      }

      _.each(section.pages, (sectionPage) => {
        if (sectionPage.state === stateName) {
          this.openSection = section;
          this.openPage = sectionPage;
          return;
        } else if (sectionPage.linkedStates && sectionPage.linkedStates.indexOf(stateName) >= 0) {
          this.openSection = section;
          this.openPage = sectionPage;
          return;
        }
      });
    });
  }
}
